var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIconNotlogged(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5566 12C22.5566 13.5913 21.9245 15.1174 20.7993 16.2426C19.6741 17.3679 18.1479 18 16.5566 18C14.9653 18 13.4392 17.3679 12.314 16.2426C11.1888 15.1174 10.5566 13.5913 10.5566 12C10.5566 10.4087 11.1888 8.88258 12.314 7.75736C13.4392 6.63214 14.9653 6 16.5566 6C18.1479 6 19.6741 6.63214 20.7993 7.75736C21.9245 8.88258 22.5566 10.4087 22.5566 12Z",
    fill: "url(#paint0_linear_656_2522)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.556641 16C0.556641 11.7565 2.24235 7.68687 5.24293 4.68629C8.24351 1.68571 12.3132 0 16.5566 0C20.8001 0 24.8698 1.68571 27.8703 4.68629C30.8709 7.68687 32.5566 11.7565 32.5566 16C32.5566 20.2435 30.8709 24.3131 27.8703 27.3137C24.8698 30.3143 20.8001 32 16.5566 32C12.3132 32 8.24351 30.3143 5.24293 27.3137C2.24235 24.3131 0.556641 20.2435 0.556641 16ZM16.5566 2C13.9202 2.00014 11.3374 2.74473 9.10545 4.14806C6.87352 5.55139 5.08321 7.55642 3.94057 9.93239C2.79793 12.3084 2.34941 14.9587 2.64664 17.5783C2.94386 20.198 3.97475 22.6804 5.62064 24.74C7.04064 22.452 10.1666 20 16.5566 20C22.9466 20 26.0706 22.45 27.4926 24.74C29.1385 22.6804 30.1694 20.198 30.4666 17.5783C30.7639 14.9587 30.3153 12.3084 29.1727 9.93239C28.0301 7.55642 26.2398 5.55139 24.0078 4.14806C21.7759 2.74473 19.1931 2.00014 16.5566 2Z",
    fill: "url(#paint1_linear_656_2522)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_656_2522",
    x1: 2.92168,
    y1: 16.572,
    x2: 33.1296,
    y2: 17.5308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61008F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_656_2522",
    x1: 2.92168,
    y1: 16.572,
    x2: 33.1296,
    y2: 17.5308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61008F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9747FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconNotlogged);
export default __webpack_public_path__ + "static/media/profile-icon-notlogged.a2dd52405a8b758a262304641fd6984c.svg";
export { ForwardRef as ReactComponent };